import {
  Pipe,
  PipeTransform,
} from '@angular/core';
import {NumberConverter} from '../functions/number-converter';
import {Constants} from '../constants/constants';

@Pipe({
  name: 'pasteApostropheAfterEachThreeNums',
})
export class PasteApostropheAfterEachThreeNumsPipe implements PipeTransform {

  transform(value: number | null | undefined): string | number {
    if (value === null || value === undefined) {
      return Constants.DASH;
    }
    return NumberConverter.pasteApostropheAfterEachThreeNums(value) || 0;
  }

}
